import GuestLayout from './GuestLayout';
import TrackingStatus from './TrackingStatus';

const partnerName = 'Shipium';
const title = 'Tracking';

const TrackingStatusPage = () => {
  return (
    <GuestLayout title={title} partnerName={partnerName}>
      <TrackingStatus />
    </GuestLayout>
  );
};
export default TrackingStatusPage;
